import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import startOfToday from 'date-fns/start_of_today';
import startOfYesterday from 'date-fns/start_of_yesterday';
import filter from 'lodash/filter';
import format from 'date-fns/format';
import getTime from 'date-fns/get_time';
import { encode } from 'base-64';
import { Base64 } from 'js-base64';
import moment from 'moment';
import { addDays, ymd } from '../utils/date';
import isValidJsonString from '../utils/is-valid-json-string';
import calendar from './calendar-modal';

import { EDELIVERY, SELECTED_RANGE, DATE_FORMAT, ALL_REPORT_PORTFOLIO, ReportTypes, CATEGORY_ID, REPORT_PORTFOLIO_ID, SUCCESS_RETURN_CODE, CUSTOM_REPORT_TYPES, FILTER_CATEGORY } from '../../@extension/CH/src/screens/reports/constants';
import {  PORTFOLIO_RELIDTYPE, REPORTS } from '../constants';
import Guid from '../utils/guid';
import envConfig from '../../db-env-build';
import { EBANKINGWEBLUX, RM_REGION, WEBSSO_ERROR_CODES } from '../constants';
// import console = require('console');
import { isWithinInterval } from 'date-fns';
import getIntervalObject from '../../../dbk-app/src/utils/getIntervalObject';

const EDELIVERY_PATH = 'roster.data.edelivery';
const EDELIVERY_PATH_REPORTS = 'roster.data.reports';

export default () => {

  const today = startOfToday();
  const yesterday = startOfYesterday();
  const past7Days = addDays(-6, today);
  const past30Days = addDays(-30, today);
  const past90Days = addDays(-90, today);
  const startOfYTD = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const past3Months = moment().subtract(3, 'months').format('YYYY-MM-DD');

  return muster()
    // custom report code starts

    .path('reports.trans.getTransactionDetails', {
      call: async ({ req }, { get, set, call }) => {
        const [startDate] = await getValues(get('reports.trans.startDate'));
        const [endDate] = await getValues(get('reports.trans.endDate'));
        const [messages] = await getValues(get('i18n.messages'));
        let dateDisplay = '';
        let pfIdArray = [];
        await set('reports.transactions.showSpinner', true);
        await set('reports.trans.isLoading', true);
        if (startDate === endDate) {
          dateDisplay = 'Showing for ' + format(new Date(startDate), 'dd MMMM yyyy');
        } else if (
          startDate !== undefined &&
          startDate.length !== 0 &&
          endDate !== undefined &&
          endDate.length !== 0
        ) {
          dateDisplay =
            'Showing: ' +
            format(new Date(startDate), 'dd MMMM yyyy') +
            ' to ' +
            format(new Date(endDate), 'dd MMMM yyyy');
        } else {
          dateDisplay = '';
        }

        // const [portfolioId] = await getValues(
        //   get('reports.user.selectedPortfolioId')
        // );
        // // var [pfIdArray] = [];
        // if (portfolioId.id === REPORT_PORTFOLIO_ID) {
        //   const [portfolioIds] = await getValues(
        //     get('reports.user.portfoliosData')
        //   );
        //   if (!portfolioIds || portfolioIds.length === 0) {
        //     await call('reports.user.setReportsPortfoliosData');
        //     [pfIdArray] = await getValues(
        //       get('reports.user.portfoliosData')
        //     );
        //   }
        //   else {
        //     pfIdArray = portfolioIds;
        //   }
        // }
        // else {
        //   pfIdArray.push(portfolioId.title);
        // }

        const [portfolioId] = await getValues(
             get('app.user.selectedPortfolioData')
           );
        if(portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS){

          pfIdArray.push(portfolioId.relId);

        }
        else {
          pfIdArray.push(portfolioId.title);
        }
          
        const pfIdParam = Base64.encode(pfIdArray.join('$'));
        const channel = 'BROWSER';
        const [oReturn] = await getValues(
          get(
            `roster.data.edelivery.transactions.getTransactionsData["${pfIdParam}"]["${startDate}"]["${endDate}"]["${channel}"]`
          )
        );
        if (oReturn) {
          isValidJsonString(oReturn).then(async (data) => {
            await Promise.all([
              // default list to render in report list  unread list
              set('reports.trans.startDate', startDate),
              set('reports.trans.endDate', endDate),
              set('reports.trans.dateDisplay', dateDisplay),
              set('reports.trans.transactionHistoryList', data),
              set('reports.trans.isLoading', false),
              set('reports.transactions.showSpinner', false),
            ]);
            if(Object.keys(data).length>250){
          
              // WMCE- 5389 The below line will satisfy the logic of removing the 251 st record
              data = data.pop();
            }
          }).catch(() => {
            Promise.all([set('reports.transactions.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          });
        } else {
          await Promise.all([
            set('reports.trans.transactionHistoryList', []),
            set('reports.trans.isLoading', false),
            set('reports.transactions.showSpinner', false)
          ]);
        }
      },
    })

    .path('reports.trans.setRange7Days', {
      call: async ({ req }, { set }) => {
        await set('reports.trans.isLoading', true);
        await set('reports.trans.startDate', ymd(past7Days));
        await set('reports.trans.endDate', ymd(yesterday));
      },
    })

    .path('reports.trans.setRange30Days', {
      call: async ({ req }, { set }) => {
        await set('reports.trans.isLoading', true);
        await set('reports.trans.startDate', ymd(past30Days));
        await set('reports.trans.endDate', ymd(yesterday));
      },
    })

    .path('reports.trans.setRange3Months', {
      call: async ({ req }, { set }) => {
        await set('reports.trans.isLoading', true);
        await set('reports.trans.startDate', ymd(past3Months));
        await set('reports.trans.endDate', ymd(yesterday));
      },
    })

    .path('reports.trans.setRangeYTD', {
      call: async ({ req }, { set }) => {
        await set('reports.trans.isLoading', true);
        // await set('reports.trans.startDate', ymd(past3Months));
        // await set('reports.trans.endDate', ymd(yesterday));
      },
    })

    .path('reports.trans.onCalendarDone', {
      call: async ({ req }, { set }) => {
        const startDate = req.args[0].fromDate
          ? req.args[0].fromDate
          : req.args[0].toDate;
        const endDate = req.args[0].toDate
          ? req.args[0].toDate
          : req.args[0].fromDate;

        if (startDate !== undefined || endDate !== undefined) {
          await set('reports.trans.startDate', ymd(startDate));
          await set('reports.trans.endDate', ymd(endDate));
        } else {
          await set('reports.trans.startDate', ymd(past7Days));
          await set('reports.trans.endDate', ymd(yesterday));
        }
      },
    })

    .import('reports.trans.calendar', calendar(), {
      onDone: ref('reports.trans.onCalendarDone'),
    })


    .path('reports.custom.downloads.excelData', {
      call: async ({ req, res }, { get, set, call }) => {
        const requestData = req.args[0];
        const [portfolioId] = await getValues(
          get('reports.user.selectedPortfolioId')
        );
        let pfIdArray = [];
        if (portfolioId.id === REPORT_PORTFOLIO_ID) {
          const [portfolioIds] = await getValues(
            get('reports.user.portfoliosData')
          );
          if (!portfolioIds || portfolioIds.length === 0) {
            await call('reports.user.setReportsPortfoliosData');
            [pfIdArray] = await getValues(
              get('reports.user.portfoliosData')
            );
          }
          else {
            pfIdArray = portfolioIds;
          }
        }
        else {
          pfIdArray.push(portfolioId.title);
        }
        const pfIdParam = encode(pfIdArray.join('$'));
        const base64 = encode(JSON.stringify(requestData));
        const inputParam = `${pfIdParam}#@#${base64}`;
        const guidStr = Guid();
        const [oReturn] = await getValues(get(`roster.data.edelivery.positionDownloads.downloads["${inputParam}"]["${guidStr}"]`));
        isValidJsonString(oReturn).then(async (data) => {
          await set('reports.custom.downloads.result', data);
        });
      },
    })

    // custom report code ends
    // CH Code start
    .path('reports.user.selectedPortfolioId', variable(ALL_REPORT_PORTFOLIO))
    .path('reports.user.selectedPortfolioData', variable())
    .path('reports.user.portfoliosData', variable([]))
    .path('reports.user.setReportsPortfoliosData', {
      call: async ({ req }, { get, set, call }) => {
        const portfolioElements = [];

        const [userPFIds] = await getValues(
          get('app.user.portfoliosData')
        );
        userPFIds.map((portfolio) => {
          if (portfolio.isEDeliveryAvailable) {
            let existflag = false;
            portfolioElements.map((portfolioEle) => {
              if (
                portfolioEle.id === portfolio.id &&
                portfolioEle.relId === portfolio.relId
              ) {
                existflag = true;
              }
            });
            const key = portfolio.relId;
            if (!existflag) {
              // filtering consolidated portfolios
              if (key && key.substring(key.length - 4, key.length) !== 'CONS') {
                portfolioElements.push(portfolio);
              }
              else if (key === null) {
                portfolioElements.push(portfolio);
              }
            }
          }
          return portfolioElements;
        });

        const parsedPortfolioList = [];
        portfolioElements.map((portfolio) => {
          parsedPortfolioList.push(portfolio.title);
        });
        await set('reports.user.reportsPortfoliosData', portfolioElements);
        await set('reports.user.portfoliosData', parsedPortfolioList);
      }
    })
    // .path('reports.statements.setDateRanges', {
    //   call: async ({ req }, { get, set, call }) => {
    //     await set('reports.daterange.lastweek.startDate', ymd(past7Days));
    //     await set('reports.daterange.lastweek.endDate', ymd(today));
    //     await set('reports.daterange.lastmonth.startDate', ymd(past30Days));
    //     await set('reports.daterange.lastmonth.endDate', ymd(today));
    //   },
    // })
    .path('reports.getDocuments', {
      call: async ({ req }, { get, set, call }) => {
        // await set('reports.statement.loading', true);
        // const { dateRange } = req.args[0];
        // const { categoryIds } = req.args[0];
        await set('reports.blurModalError', null)
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        await set('reports.showSpinner', true);
        const [dropdownDateRangeText] = await getValues(get('reports.dropdownDateRangeText'));
        if(!dropdownDateRangeText){
          await set('reports.dropdownDateRangeText', messages["app.trade.filter.selectDate"])
        }
        // const fromRecievedDate = format(past30Days, DATE_FORMAT.EDELIVERY);
        // const toRecievedDate = format(today, DATE_FORMAT.EDELIVERY);

        // const fromDate = ymd(past30Days);                                    // to be deleted
        const fromDate = ymd(past90Days);
        const fromRecievedDate = new Date(fromDate).toISOString();
        // const toDate = ymd(addDays(1, today));
        const toDate = ymd(today);
        const toRecievedDate = new Date(toDate).toISOString();

        // const [portfolioId] = await getValues(
        //   get('reports.user.selectedPortfolioId')
        // );
        // let pfIdArray = [];
        // if (portfolioId.id === REPORT_PORTFOLIO_ID) {
        //   const [portfolioIds] = await getValues(
        //     get('reports.user.portfoliosData')
        //   );
        //   if (!portfolioIds || portfolioIds.length === 0) {
        //     await call('reports.user.setReportsPortfoliosData');
        //     [pfIdArray] = await getValues(
        //       get('reports.user.portfoliosData')
        //     );
        //   }
        //   else {
        //     pfIdArray = portfolioIds;
        //   }

        // }
        // else {
        //   pfIdArray.push(portfolioId.title);
        // }
        let pfIdArray = [];
        const [portfolioId] = await getValues(
             get('app.user.selectedPortfolioData')
           );
        if(portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS){
          await call('portfolio.getSelectedIdData');

          pfIdArray.push(portfolioId.relId);

        }
        else {
          pfIdArray.push(portfolioId.title);
        }
          
        if (pfIdArray.length === 0) {
          await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.noPFIdErrorMessage'])]);
        } else {
          const pfIdParam = Base64.encode(pfIdArray.join('$'));
          const channel = 'WEB';
          // let portfoliofIdArray = [];

          // BP_level portfolio handling based on portfolio numbers

          // [portfoliofIdArray] = await getValues(
          //   get('reports.user.portfoliosData')
          // );
          let allPortfolios = false;
          if (portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS) {
            allPortfolios = true;
          } else {
            allPortfolios = false;
          }
          const inputParam = `${pfIdParam}#@#${channel}#@#${fromRecievedDate}#@#${toRecievedDate}#@#${allPortfolios}`;
          const [result] = await getValues(
            get(
              `${EDELIVERY_PATH}.initializeEDelivery["${inputParam}"]["${guidStr}"]`
            )
          );
          
          isValidJsonString(result).then(async (data) => {
            // if(data.dwoMessage.messages.length !== 0){
            if (data.dwoMessage.messages !== null) {
              await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', data.dwoMessage.messages[0].errorDesc)]);
            } else if (data.message && data.message !== '') {
              await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
            } else if (data.returnCode === SUCCESS_RETURN_CODE) {
              const statementlist = data.categoryIdAndDocsList || [];
              const mailBoxIds = data.mailBoxIds || [];
              const unreadStatementList = data.unreadCategoryIdAndDocsList || [];
              const totalUnreadDocs = data.totalUnreadDocs || 0;
              const categoryList = (statementlist.map((item) => item.docCategoryId))
                .reduce((acc, ele) => acc.concat(ele), []);
              const [categoryOrder] = await getValues(get('reports.statement.categoryOrder'));
              if(!categoryOrder.length){
                await set('reports.statement.categoryOrder', statementlist.map(item => item.docCategoryName));
                await set('reports.statement.defaultList', statementlist)
              } else {
                let copyStatementlist = [];
                categoryOrder.map( categoryName => {
                  statementlist.map( categoryItem => {
                    if(categoryName === categoryItem.docCategoryName)
                      copyStatementlist.push(categoryItem);
                  })
                });
                await set('reports.statement.defaultList', copyStatementlist);
              }
              await Promise.all([
                // default list to render in report list  unread list
                set('reports.showSpinner', false),
                set('reports.statement.defaultUnreadList', filter(unreadStatementList, (ob) => ob.addhocCat !== true)),
                set('reports.rm.defaultUnreadList', filter(statementlist, (ob) => ob.addhocCat === true)),
                set('reports.totalUnreadDocs', totalUnreadDocs),
                set('reports.mailBoxIds', mailBoxIds),
                set('reports.statement.loading', false),
                set('reports.isRefreshInProgress', false),
                set('reports.categoryIDList', categoryList)
              ]);
              await call('reports.setSelectedRangeList');
              await call('reports.getStatementTypes');
            } else {
              await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
            }

          }).catch(() => {
            Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          });
        }
      },
    })
    .path('reports.setBlurModalError', {
      call: async ({ req }, { get, set, call }) => {
        const errorData = req.args[0];
        await set('reports.blurModalError', errorData);
      },
    })
    .path('reports.generateAdhocReport', {
      call: async ({ req }, { get, set, call }) => {
        const reqBody = req.args[0];
        console.log(reqBody);
        
        await set('reports.showSpinner', true);

        const guidStr = Guid();
        const channel = 'WEB';
        const [messages] = await getValues(get('i18n.messages'));        

        const inputParam = `${channel}#@#${reqBody.accountId}#@#${reqBody.reportDurationFrom}#@#${reqBody.reportDurationTo}#@#${reqBody.reportTypeId}#@#${reqBody.isAccount}`;

        const [result] = await getValues(
          get(
            `${EDELIVERY_PATH}.reports.createAdhocReport["${inputParam}"]["${guidStr}"]`
          )
        );

        isValidJsonString(result).then(async (data) => {
          await set('reports.showSpinner', false);

          if (+data.code === WEBSSO_ERROR_CODES.BAD_REQUEST) {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.adhoc.errorMessage', messages['app.reports.orderReport.invalidInputErrMsg'])]);
          } else if (+data.code === WEBSSO_ERROR_CODES.serviceUnAvailable) {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.adhoc.errorMessage', messages['app.reports.orderReport.internalServerErrMsg'])]);
          }
          if(+data.code === WEBSSO_ERROR_CODES.OK) {
            await call('rsa.changePage', '/reports/adhoc-statement/success');
          }
          
        }).catch((err) => {
          Promise.all([set('reports.showSpinner', false)], [set('reports.adhoc.errorMessage', messages['app.reports.orderReport.internalServerErrMsg'])]);
        });

      },
    })
    .path('reports.getStatementTypes', {
      call: async ({ req }, { get, set, call }) => {
        await set('reports.showSpinner', true);
        const guidStr = Guid();
        const channel = 'WEB';
        const [messages] = await getValues(get('i18n.messages'));        

        // const inputParam = `${channel}#@#${pfIdParam}#@#${mailBoxIdParam}#@#${categoryIdParam}#@#${fromRecievedDate}#@#${toRecievedDate}#@#${allPortfolios}`;
        const [result] = await getValues(
          get(
            `${EDELIVERY_PATH}.reports.statementTypes["${guidStr}"]`
          )
        );

        isValidJsonString(result).then(async (data) => {
          
          await set('reports.showSpinner', false);

          if (data.messageType && data.messageType === "ERROR") {
            
            await Promise.all([set('reports.showSpinner', false)], [set('reports.adhoc.errorMessage', messages['app.chedelivery.reports.systemErrorMessage'])]);
          }
          await set('reports.adhoc.statementTypes', data);
          
        }).catch((err) => {
          Promise.all([set('reports.showSpinner', false)], [set('reports.adhoc.errorMessage', messages['app.chedelivery.reports.systemErrorMessage'])]);
        });

      },
    })
    .path('reports.fetchDocumentsForCategories', {
      call: async ({ req }, { get, set, call }) => {
        await set('reports.showSpinner', true);
        await set('reports.blurModalError', null)
        const startDate = req.args[0];
        const endDate = req.args[1];

        if (startDate && endDate) {
          await set('reports.startDate', ymd(startDate));
          await set('reports.endDate', ymd(endDate));
        }
        const guidStr = Guid();
        const channel = 'WEB';
        const [messages] = await getValues(get('i18n.messages'));
        /*
        const [portfolioId] = await getValues(
          get('reports.user.selectedPortfolioId')
        );
        let pfIdArray = [];
        const [portfolioIds] = await getValues(
          get('reports.user.portfoliosData')
        );
        if (portfolioId.id === REPORT_PORTFOLIO_ID) {
          pfIdArray = portfolioIds;
        }
        else {
          pfIdArray.push(portfolioId.title);
        }
        */
       let pfIdArray = [];
       const [portfolioId] = await getValues(
        get('app.user.selectedPortfolioData')
      );
        if (portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS) {
          [pfIdArray] = await getValues(
            get('user.selectedPortfolioIds')
          );
        }
        else {
          pfIdArray.push(portfolioId.title);
        }
        const pfIdParam = Base64.encode(pfIdArray.join('$'));

        const mailBoxIdArray = [];
        // const [mailBoxId] = await getValues(
        //   get('reports.selectedmailBoxId')
        // );
        const [mailBoxIds] = await getValues(
          get('reports.mailBoxIds')
        );
        mailBoxIds.map((item) => {
          mailBoxIdArray.push(item.mailBoxId);
        });

        const mailBoxIdParam = Base64.encode(mailBoxIdArray.join('$'));

        //    const categoryIds  = CATEGORY_ID;
        //    const categoryIdArray = [];
        //    categoryIdArray.push(categoryIds);
        const [categoryIds] = await getValues(
          get('reports.categoryIDList')
        );
        const categoryIdParam = Base64.encode(categoryIds.join('$'));

        // const [fromRecievedDateMuster] = await getValues(get('reports.startDate'));
        // const [toRecievedDateMuster] = await getValues(get('reports.endDate'));
        // const fromRecievedDate = format(fromRecievedDateMuster, 'YYYY-MM-DDTHH:mm:ssZ');
        // const toRecievedDate = format(toRecievedDateMuster, 'YYYY-MM-DDTHH:mm:ssZ');
        const fromRecievedDate = new Date(startDate).toISOString();
        // const todayd = ymd(today);
        // const toDate = ymd(addDays(1, new Date(toRecievedDateMuster)));
        const toDate = ymd(new Date(endDate));
        const toRecievedDate = new Date(toDate).toISOString();
        // BP_level portfolio handling based on portfolio numbers
        /*
        let portfoliofIdArray = [];
        [portfoliofIdArray] = await getValues(
          get('reports.user.portfoliosData')
        );
        let allPortfolios = false;
        if (portfolioId.id === REPORT_PORTFOLIO_ID || portfoliofIdArray.length === 1) {
          allPortfolios = true;
        } else {
          allPortfolios = false;
        }
        */
       let allPortfolios = false;
          if (portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS) {
            allPortfolios = true;
          } else {
            allPortfolios = false;
          }
        const inputParam = `${channel}#@#${pfIdParam}#@#${mailBoxIdParam}#@#${categoryIdParam}#@#${fromRecievedDate}#@#${toRecievedDate}#@#${allPortfolios}`;
        const [result] = await getValues(
          get(
            `${EDELIVERY_PATH}.fetchDocumentsForCategories["${inputParam}"]["${guidStr}"]`
          )
        );

        isValidJsonString(result).then(async (data) => {
          if (data.messageType && data.messageType === "ERROR") {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          }
          else if (data.dwoMessage.messages !== null) {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', data.dwoMessage.messages[0].errorDesc)]);
          } else if (data.message && data.message !== '') {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          } else if (data.returnCode === SUCCESS_RETURN_CODE) {
            const statementlist = data.categoryIdAndDocsList || [];
            const unreadStatementList = data.unreadCategoryIdAndDocsList || [];
            const customUnreadListforAdhoc = filter(statementlist, (ob) => ob.addhocCat === true);
            await Promise.all([
              [set('reports.showSpinner', false)],
              set('reports.statement.customRangeUnreadList', filter(unreadStatementList, (ob) => ob.addhocCat !== true)),
              set('reports.rm.customRangeUnreadList', customUnreadListforAdhoc),
              set('reports.statement.loading', false),
            ]);
            const [categoryOrder] = await getValues(get('reports.statement.categoryOrder'));
            let copyCustomRangeList = [];
            categoryOrder.map( categoryName => {
              statementlist.map( categoryItem => {
                if(categoryName === categoryItem.docCategoryName)
                  copyCustomRangeList.push(categoryItem);
              })
            });
            await set('reports.statement.customRangeList', copyCustomRangeList);
            await call('reports.setTotalUndreadDocData', unreadStatementList, SELECTED_RANGE.CUSTOM);
            await call('reports.rm.setTotalUndreadDocData', customUnreadListforAdhoc, SELECTED_RANGE.CUSTOM);
          } else {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          }
        }).catch(() => {
          Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
        });
      },
    })
    .path('reports.markDocumentsAsRead', {
      call: async ({ req }, { get, set, call }) => {
        // await set('reports.statement.loading', true);
        await set('reports.blurModalError', null)
        const documentIds = req.args[0];
        const [messages] = await getValues(get('i18n.messages'));
        const documentIdParam = Base64.encode(documentIds.join('$'));
        const channel = 'WEB';
        // const { categoryIds } = req.args[0];
        const inputParam = `${documentIdParam}#@#${channel}`;
        await Promise.all([set('reports.showSpinner', true)]);
        const [result] = await getValues(
          get(
            `${EDELIVERY_PATH}.markDocumentsAsRead["${inputParam}"]`
          )
        );
        isValidJsonString(result).then(async (data) => {
          if (data.dwoMessage.messages !== null) {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', data.dwoMessage.messages[0].errorDesc)]);
          } else if (data.message && data.message !== '') {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          } else if (data.returnCode === SUCCESS_RETURN_CODE) {
            await Promise.all([set('reports.showSpinner', false)]);
            await call('reports.getDocuments');
            const [selectedDateRange] = await getValues(
              get('reports.selectedReportDetailsDateRange')
            );
            if (selectedDateRange === SELECTED_RANGE.CUSTOM) {
              const [fromRecievedDateMuster] = await getValues(get('reports.startDate'));
              const [toRecievedDateMuster] = await getValues(get('reports.endDate'));
              await call('reports.fetchDocumentsForCategories', fromRecievedDateMuster, toRecievedDateMuster);
            }
          } else {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          }
        }).catch(() => {
          Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
        });
      },
    })
    .path('reports.setPdfBinaryData', {
      call: async ({ req }, { get, set, call }) => {
        const binaryData = req.args[0];
        await set('reports.pdfBinaryData', binaryData);
      },
    })
    .path('reports.downloadDocuments', {
      call: async ({ req }, { get, set, call }) => {
        // await set('report.pdfBinaryData', null);
        const [messages] = await getValues(get('i18n.messages'));
        const channel = 'WEB';
        await set('reports.pdfDataDownloadInProgress', true);
        await set('reports.blurModalError', null)

        const documentIds = req.args[0];
        await Promise.all([set('reports.showSpinner', true)], [set('reports.docIDforDownload', documentIds)]);
        const documentIdParam = Base64.encode(documentIds);

        const inputParam = `${channel}#@#${documentIdParam}`;

        const [result] = await getValues(
          get(
            `${EDELIVERY_PATH}.downloadDocuments["${inputParam}"]`
          )
        );
        isValidJsonString(result).then(async (data) => {

          if (data.dwoMessage.messages !== null) {
            await Promise.all(
              [set('reports.blurModalError', data.dwoMessage.messages[0].errorDesc)],
              [set('reports.showSpinner', false)]);
          } else if (data.message && data.message !== '') {
            await Promise.all(
              [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])],
              [set('reports.showSpinner', false)]);
          } else if (data.returnCode === SUCCESS_RETURN_CODE) {
            await Promise.all(
              [set('reports.pdfBinaryData', data.base64EncodedBinaryData)],
              [set('reports.showSpinner', false)]);
          } else {
            await Promise.all(
              [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'],
                [set('reports.showSpinner', false)])]);
          }
        }).catch(() => {
          Promise.all(
            [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'],
              [set('reports.showSpinner', false)])]);
        });;
      },
    })

    // .path('reports.setRange7Days', {
    //   call: async ({ req }, { get, set, call }) => {
    //     await set('reports.startDate', ymd(past7Days));
    //     await set('reports.endDate', ymd(today));
    //   },
    // })
    // .path('reports.setRange30Days', {
    //   call: async ({ req }, { get, set, call }) => {
    //     await set('reports.startDate', ymd(past30Days));
    //     await set('reports.endDate', ymd(today));
    //   },
    // })
    // .path('reports.setRangeYTD', {
    //   call: async ({ req }, { get, set, call }) => {
    //     await set('reports.startDate', ymd(startOfYTD));
    //     await set('reports.endDate', ymd(today));
    //   },
    // })
    // .path('reports.onCalendarDone', {
    //   call: async ({ req }, { get, set, call }) => {

    //     const startDate = req.args[0].fromDate ? req.args[0].fromDate : req.args[0].toDate;
    //     const endDate = req.args[0].toDate ? req.args[0].toDate : req.args[0].fromDate;

    //     if (startDate && endDate) {
    //       await set('reports.startDate', format(startDate, 'YYYY-MM-DDTHH:mm:ssZ'));
    //       await set('reports.endDate', format(endDate, 'YYYY-MM-DDTHH:mm:ssZ'));
    //     }
    //   },
    // })
    .import('reports.calendar', calendar(), {
      onDone: ref('reports.fetchDocumentsForCategories')
    })
    .path('reports.setSelectedCategoryId', {
      call: async ({ req }, { get, set, call }) => {
        await set('reports.selectedCategoryId', null);
        const categoryId = req.args[0];
        const categoryName = req.args[1];
        await set('reports.selectedCategoryId', categoryId);
        await set('reports.selectedCategoryName', categoryName);
        await set('reports.showUnreadOnlyChecked', false);
      },
    })
    .path('reports.setReportDetailDateRange', {
      call: async ({ req }, { get, set, call }) => {
        // await set('reports.selectedReportDetailsDateRange', null);
        const selectedRange = req.args[0];
        await set('reports.selectedReportDetailsDateRange', selectedRange);
      },
    })
    .path('reports.setSelectedReportType', {
      call: async ({ req }, { get, set, call }) => {
        // await set('reports.setSelectedReportType', null);
        const typeValue = req.args[0];

        await Promise.all([
          await set('reports.selectedReportType', typeValue),
          await set('reports.totalDocsCustomRange', 0),
          // await set('reports.startDate', startOfYTD),
          // await set('reports.endDate', today),
          await set('reports.statement.customRangeList', []),
          await set('reports.statement.customRangeUnreadList', [])
        ]);
      },
    })
    // duration will be dates/week/month
    .path('reports.setDuration', {
      call: async ({ req }, { set }) => {
        await set('reports.duration', req.args[0]);
      }
    })
    .path('reports.setSelectedRangeList', {
      call: async ({ req }, { get, set, call }) => {
        const [selectedCategoryId] = await getValues(
          get('reports.selectedCategoryId')
        );
        // range: LAST_WEEK, LAST_MONTH and DATES
        const [selectedRange] = await getValues(
          get('reports.selectedReportDetailsDateRange')
        );

        // if (selectedRange !== SELECTED_RANGE.CUSTOM) {

        // filtering default list for 7 days
        const [defaultlist] = await getValues(get('reports.statement.defaultList'));

        const list = Object.assign([], defaultlist);
        call('reports.setLastWeekFilteredList', list, undefined)
        call('reports.setLastMonthFilteredList', list);
        // filtering default unread list for 7 days
        const [defaultUnreadList] = await getValues(get('reports.statement.defaultUnreadList'));
        const [defaultUnreadListForRM] = await getValues(get('reports.rm.defaultUnreadList'));
        const unreadListforRM = Object.assign([], defaultUnreadListForRM);
        const unreadList = Object.assign([], defaultUnreadList);
        call('reports.setLastWeekFilteredList', unreadList, EDELIVERY.UNREAD_CATEGORY_ID);
        call('reports.rm.setLastWeekUnreadList', unreadListforRM);
        call('reports.rm.setLastMonthUnreadList', unreadListforRM);


        const [lastWeekList] = await getValues(get('reports.statement.lastWeekUnread'));

        call('reports.setTotalUndreadDocData', lastWeekList, SELECTED_RANGE.LAST_WEEK);
        call('reports.setTotalUndreadDocData', unreadList, SELECTED_RANGE.LAST_MONTH);

        const [lastWeekListforRM] = await getValues(get('reports.rm.lastWeekUnread'));
        const [lastMonthListforRM] = await getValues(get('reports.rm.lastMonthUnread'));

        call('reports.rm.setTotalUndreadDocData', lastWeekListforRM, SELECTED_RANGE.LAST_WEEK);
        call('reports.rm.setTotalUndreadDocData', lastMonthListforRM, SELECTED_RANGE.LAST_MONTH);
        call('reports.rm.setTotalUndreadDocData', unreadListforRM, SELECTED_RANGE.LAST_90_DAYS);

        /* // Assign 30 days list                                 // to be deleted , for future reference only
        await set('reports.statement.lastMonth', list);
        await set('reports.statement.lastMonthUnread', unreadList);
        await set('reports.rm.lastMonthUnread', unreadListforRM);
        // } */

        // Assign 90 days list
        await set('reports.statement.last90days', list);
        await set('reports.statement.last90daysUnread', unreadList);
        await set('reports.rm.last90daysUnread', unreadListforRM);
        // if(list.length > 0)
        //   call('reports.setSelectedCategoryId', list[0].docCategoryId, list[0].docCategoryName);
        // }
      }
    })
    .path('reports.rm.setLastWeekUnreadList', {
      call: async ({ req }, { get, set, call }) => {
        const interval = getIntervalObject(past7Days, today);
        const endDate = getTime(today);
        const startDate = getTime(past7Days);
        const list = req.args[0];
        const listCopy = JSON.parse(JSON.stringify(list));
        const filteredList = [];
        listCopy.map((listItem) => {
          const filteredListItem = listItem;
          const listMetaData = filter(listItem.documentMetadataList, (o) =>
            isWithinInterval(new Date(new Date(o.receivedDate).setHours(0,0,0,0)), interval));

          if (listMetaData && listMetaData.length > 0) {
            const unreadlist = filter(listMetaData, (item) => (!item.read));
            const countOfUnreadDocs = unreadlist.length;
            filteredListItem.documentMetadataList = listMetaData;
            filteredListItem.countOfUnreadDocs = countOfUnreadDocs;
            filteredList.push(filteredListItem);
          }
          else {
            filteredListItem.documentMetadataList = [];
            filteredListItem.countOfUnreadDocs = 0;
            filteredList.push(filteredListItem);
          }
          return listItem;
        })
        await set('reports.rm.lastWeekUnread', filteredList);
      }
    })

    .path('reports.rm.setLastMonthUnreadList', {
      call: async ({ req }, { get, set, call }) => {
        const interval = getIntervalObject(past30Days, today);
        const endDate = getTime(today);
        const startDate = getTime(past30Days);
        const list = req.args[0];
        const listCopy = JSON.parse(JSON.stringify(list));
        const filteredList = [];
        listCopy.map((listItem) => {
          const filteredListItem = listItem;
          const listMetaData = filter(listItem.documentMetadataList, (o) =>
            isWithinInterval(new Date(new Date(o.receivedDate).setHours(0,0,0,0)), interval));

          if (listMetaData && listMetaData.length > 0) {
            const unreadlist = filter(listMetaData, (item) => (!item.read));
            const countOfUnreadDocs = unreadlist.length;
            filteredListItem.documentMetadataList = listMetaData;
            filteredListItem.countOfUnreadDocs = countOfUnreadDocs;
            filteredList.push(filteredListItem);
          }
          else {
            filteredListItem.documentMetadataList = [];
            filteredListItem.countOfUnreadDocs = 0;
            filteredList.push(filteredListItem);
          }
          return listItem;
        })
        await set('reports.rm.lastMonthUnread', filteredList);
      }
    })

    .path('reports.setLastWeekFilteredList', {
      call: async ({ req }, { get, set, call }) => {
        const interval = getIntervalObject(past7Days, today);
        // Last 7days date
        // const startDate = getTime('2018-05-15T00:00:00+02:00');
        // const endDate = getTime('2018-09-24T00:00:00+02:00');
        // const startDate = getTime(format(past7Days, DATE_FORMAT.EDELIVERY));
        // const endDate = getTime(format(today, DATE_FORMAT.EDELIVERY));
        // const todaysDate = ymd(today);
        // const endDate = getTime(new Date(todaysDate).toISOString());

        const endDate = getTime(today);

        // const startDate = getTime(new Date(lastWeekDate).toISOString());
        const startDate = getTime(past7Days);

        const list = req.args[0];
        const listCopy = JSON.parse(JSON.stringify(list));
        const category = req.args[1];
        const filteredList = [];
        listCopy.map((listItem) => {
          const filteredListItem = listItem;
          const listMetaData = filter(listItem.documentMetadataList, (o) =>
            isWithinInterval(new Date(new Date(o.receivedDate).setHours(0,0,0,0)), interval));

          if (listMetaData && listMetaData.length > 0) {
            const unreadlist = filter(listMetaData, (item) => (!item.read));
            const countOfUnreadDocs = unreadlist.length;
            filteredListItem.documentMetadataList = listMetaData;
            filteredListItem.countOfUnreadDocs = countOfUnreadDocs;
            filteredList.push(filteredListItem);
          }
          else {
            if (category === EDELIVERY.UNREAD_CATEGORY_ID) {
              return listItem;
            }
            filteredListItem.documentMetadataList = [];
            filteredListItem.countOfUnreadDocs = 0;
            filteredList.push(filteredListItem);

          }
          return listItem;
        })
        const rmFilteredList = [];
        if (category === EDELIVERY.UNREAD_CATEGORY_ID) {
          await set('reports.statement.lastWeekUnread', filteredList);
        } else {
          await set('reports.statement.lastWeek', filteredList);
        }
      }
    })
    .path('reports.setLastMonthFilteredList', {
      call: async ({ req }, { get, set, call }) => {
        const interval = getIntervalObject(past30Days, today);
        const endDate = getTime(today);

        const startDate = getTime(past30Days);

        const list = req.args[0];
        const listCopy = JSON.parse(JSON.stringify(list));
        const filteredList = [];
        listCopy.map((listItem) => {
          const filteredListItem = listItem;
          const listMetaData = filter(listItem.documentMetadataList, (o) =>
            isWithinInterval(new Date(new Date(o.receivedDate).setHours(0,0,0,0)), interval));

          if (listMetaData && listMetaData.length > 0) {
            const unreadlist = filter(listMetaData, (item) => (!item.read));
            const countOfUnreadDocs = unreadlist.length;
            filteredListItem.documentMetadataList = listMetaData;
            filteredListItem.countOfUnreadDocs = countOfUnreadDocs;
            filteredList.push(filteredListItem);
          }
          else {
            filteredListItem.documentMetadataList = [];
            filteredListItem.countOfUnreadDocs = 0;
            filteredList.push(filteredListItem);
          }
        });
        await set('reports.statement.lastMonth', filteredList);
      }
    })
    .path('reports.rm.setTotalUndreadDocData', {
      call: async ({ req }, { get, set, call }) => {
        // Last 7days date

        const list = req.args[0];
        const range = req.args[1];
        let totalUnreadDocs = 0;
        list.map((listItem) => {
          const metaData = listItem.documentMetadataList;
          if (metaData) {
            const unreadList = filter(metaData, (item) => (!item.read));
            if (unreadList){
            totalUnreadDocs += unreadList.length
            }
          }
          return listItem;
        });
        if (range === SELECTED_RANGE.CUSTOM) {
          await set('reports.rm.customRangeTotalUnreadDocs', totalUnreadDocs);
        } else if (range === SELECTED_RANGE.LAST_WEEK) {
          await set('reports.rm.lastWeekTotalUnreadDocs', totalUnreadDocs);
        }else if(range === SELECTED_RANGE.LAST_MONTH){
          await set('reports.rm.lastMonthTotalUnreadDocs', totalUnreadDocs);
        } else {
          await set('reports.rm.last90daysTotalUnreadDoc', totalUnreadDocs);
        }
      }
    })
    .path('reports.setTotalUndreadDocData', {
      call: async ({ req }, { get, set, call }) => {
        // Last 7days date

        const list = req.args[0];
        const range = req.args[1];
        let totalUnreadDocs = 0;
        list.map((listItem) => {
          const metaData = listItem.documentMetadataList;
          if (metaData) {
            // const unreadList = filter(metaData, (item) => (!item.read));
            // if (unreadList){
            totalUnreadDocs += metaData.length
            // }
          }
          return listItem;
        });
        if (range === SELECTED_RANGE.CUSTOM) {
          await set('reports.statement.customRangeTotalUnreadDocs', totalUnreadDocs);
        } else if (range === SELECTED_RANGE.LAST_WEEK) {
          await set('reports.statement.lastWeekTotalUnreadDocs', totalUnreadDocs);
        } else {
          await set('reports.statement.lastMonthTotalUnreadDocs', totalUnreadDocs);
        }
      }
    })
    .path('reports.setTotalDocs', {
      call: async ({ req }, { get, set, call }) => {
        const totalDocsInWeek = req.args[0];
        const totalDocsInMonth = req.args[1];
        const totalDocsCustomRange = req.args[2];
        await set('reports.totalDocs7Days', totalDocsInWeek);
        await set('reports.totalDocs30Days', totalDocsInMonth);
        await set('reports.totalDocsCustomRange', totalDocsCustomRange);
      }
    })
    .path('reports.refreshReportsView', {
      call: async ({ req }, { get, set, call }) => {
        const [reportType] = await getValues(
          get('reports.selectedReportType')
        );
        if (reportType === ReportTypes.STATEMENTS) {
          await call('reports.resetStatmentsVariables');
          await call('reports.getDocuments');
        }

      }
    })
    .path('reports.resetStatmentsVariables', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        await Promise.all([
          await set('reports.isRefreshInProgress', true),
          await set('reports.user.selectedPortfolioId', ALL_REPORT_PORTFOLIO),
          await set('reports.selectedReportDetailsDateRange', SELECTED_RANGE.LAST_90_DAYS),
          await set('reports.selectedCategoryId', EDELIVERY.UNREAD_CATEGORY_ID),
          await set('reports.selectedCategoryName', messages['app.chedelivery.reports.unread']),
          await set('reports.totalDocsCustomRange', 0),
          // await set('reports.startDate', startOfYTD),
          // await set('reports.endDate', today),
          await set('reports.statement.customRangeList', []),
          // await set('reports.statement.customRangeUnreadList', [])
        ]);
      }
    })
    .path('reports.setReportDetailSelectedTab', {
      call: async ({ req }, { set }) => {
        await set('reports.selectedDetailsTab', null);
        const selectedtab = req.args[0];
        await set('reports.selectedDetailsTab', selectedtab);
      },
    })
    .path('reports.setSelectedReportTab', {
      call: async ({ req }, { set }) => {
        await set('reports.selectedReportTab', null);
        const reportTab = req.args[0];
        await set('reports.selectedReportTab', reportTab);
      },
    })
    .path('reports.trans.setTransactionDetails', {
      call: async ({ req }, { set }) => {
        await set('reports.trans.transactionHistoryList', req.args[0]);
      }
    })
    .path('reports.getTransactionSecurityAdvices', {
      call: async ({ req }, { get, set, call }) => {
        // await set('reports.statement.loading', true);
        // const { dateRange } = req.args[0];
        // const { categoryIds } = req.args[0];
        const guidStr = Guid();
        await Promise.all([
          set('reports.transaction.securityAdviceList', []),
          set('reports.showSpinner', true)
        ]);
        const [messages] = await getValues(get('i18n.messages'));

        const channel = 'WEB';
        const posId = req.args[0];
        const date = req.args[1];
        const transactioDate = new Date(date).toISOString();
        const orderNumber = req.args[2];
        // const { categoryIds } = req.args[0];
        const inputParam = `${channel}#@#${posId}#@#${transactioDate}#@#${orderNumber}`;
        const [result] = await getValues(
          get(
            `${EDELIVERY_PATH}.fetchDocumentsForOrder["${inputParam}"]["${guidStr}"]`
          )
        );
        isValidJsonString(result).then(async (data) => {
          // if(data.dwoMessage.messages !== null && data.dwoMessage.messages.length !== 0){
          if (data.dwoMessage.messages !== null) {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', data.dwoMessage.messages[0].errorDesc)]);
          } else if (data.message && data.message !== '') {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          } else if (data.returnCode === SUCCESS_RETURN_CODE) {
            const advicelist = data.documentDetails || [];
            // const advicelist = [
            //   {
            //     "adviceDocumentId": 2752003,
            //     "adviceDocumentName": "Avis-18072017-2752003",
            //     "currency": {
            //       "currencyKey": 1110,
            //       "currencyId": 2660002,
            //       "isoCode": "US",
            //       "currencyName": "USD",
            //       "ebLabelDesc": "USD",
            //       "branchCode": 4,
            //       "tech": "USD",
            //       "languageCode": "DEU"
            //     },
            //     "portfolioId": "1995611.1001",
            //     "transactionDate": "26-10-2018"
            //   },
            //   {
            //     "adviceDocumentId": 2752003,
            //     "adviceDocumentName": "Avis-18072017-2752003",
            //     "currency": {
            //       "currencyKey": 1110,
            //       "currencyId": 2660002,
            //       "isoCode": "US",
            //       "currencyName": "USD",
            //       "ebLabelDesc": "USD",
            //       "branchCode": 4,
            //       "tech": "USD",
            //       "languageCode": "DEU"
            //     },
            //     "portfolioId": "2995611.1001",
            //     "transactionDate": "26-10-2018"
            //   }
            // ];
            await Promise.all([
              // default list to render in report list  unread list
              set('reports.transaction.securityAdviceList', advicelist),
              set('reports.showSpinner', false),
            ]);
          } else {
            await Promise.all([set('reports.showSpinner', false)], [set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
          }
        }).catch(() => {
          Promise.all([
            set('reports.showSpinner', false),
            set('reports.blurModalError', messages['app.chedelivery.reports.systemErrorMessage'])]);
        });
      },
    })
    // .path('reports.setDataForNotificationList', {
    //   call: async ({ req }, { get, set, call }) => {
    //     const [lastLoginValue] = await getValues(get(['auth.lastSession']));
    //     const fromDate = format(getTime(lastLoginValue), 'YYYY-MM-DDTHH:mm:ssZ');
    //     const toDate = today;
    //     await Promise.all([
    //       await set('reports.selectedReportDetailsDateRange', SELECTED_RANGE.CUSTOM),
    //       await call('reports.fetchDocumentsForCategories', { fromDate, toDate })
    //     ]);
    //   }

    // .path('reports.daterange.lastweek.startDate', ymd(past7Days))
    // .path('reports.daterange.lastweek.endDate', ymd(today))
    .path('reports.resetDocumentData', {
      call: async ({ req }, { call, set, get }) => {
        const [selectedRange] = await getValues(
          get('reports.selectedReportDetailsDateRange')
        );
        const [fromRecievedDateMuster] = await getValues(get('reports.startDate'));
        const [toRecievedDateMuster] = await getValues(get('reports.endDate'));
        await Promise.all([
          await set('reports.pdfBinaryData', '')
        ]);
        if (fromRecievedDateMuster && toRecievedDateMuster) {
          await call('reports.fetchDocumentsForCategories', fromRecievedDateMuster, toRecievedDateMuster);
        }
        await call('reports.getDocuments');
      }
    })
    .path('reports.trans.getSelectedRangeDataForCustomReport', {
      call: async ({ req }, { call, set }) => {
        const startDate = req.args[0];
        const endDate = req.args[1];
        await Promise.all([
          set('reports.trans.startDate', ymd(startDate)),
          set('reports.trans.endDate', ymd(endDate)),
          call('reports.trans.getTransactionDetails')
        ]);
      },
    })

    .path('reports.swapCategories', {
      call: async ({ req }, { call, set, get }) => {
        const rowIndex = req.args[0];
        const copyCategoryList = [...req.args[1]];
        const [copyLastWeek, copyLastMonth, copyLast90days, copyCustomRangeList, selectedDateRange, categoryOrder , copyDefaultList] = await getValues(get([
          'reports.statement.lastWeek',
          'reports.statement.lastMonth',
          'reports.statement.last90days',
          'reports.statement.customRangeList',
          'reports.selectedReportDetailsDateRange',
          'reports.statement.categoryOrder',
          'reports.statement.defaultList'
        ]));
          
        [copyCategoryList[REPORTS.NUMBAR_OF_FIXED_TABS - 1], copyCategoryList[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex]] = [copyCategoryList[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex], copyCategoryList[REPORTS.NUMBAR_OF_FIXED_TABS - 1]];
        
        const reOrderList =[...copyCategoryList.slice(0,REPORTS.NUMBAR_OF_FIXED_TABS ), ...copyDefaultList.filter((dl) => !copyCategoryList.slice(0,REPORTS.NUMBAR_OF_FIXED_TABS ).some((tabItem) => tabItem.docCategoryName === dl.docCategoryName))];
       
       
        //[copyLastWeek[REPORTS.NUMBAR_OF_FIXED_TABS - 1], copyLastWeek[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex]] = [copyLastWeek[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex], copyLastWeek[REPORTS.NUMBAR_OF_FIXED_TABS - 1]];
        const reorderedLastWeek = reOrderList.map((reorderItem)=> copyLastWeek.find((listItem)=>listItem.docCategoryName === reorderItem.docCategoryName ))
        await set('reports.statement.lastWeek', reorderedLastWeek);
        
        // [copyLastMonth[REPORTS.NUMBAR_OF_FIXED_TABS - 1], copyLastMonth[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex]] = [copyLastMonth[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex], copyLastMonth[REPORTS.NUMBAR_OF_FIXED_TABS - 1]]; 
        const reorderedLastMonth = reOrderList.map((reorderItem)=> copyLastMonth.find((listItem)=>listItem.docCategoryName === reorderItem.docCategoryName ))
        await set('reports.statement.lastMonth', reorderedLastMonth);
       
        
       // [copyLast90days[REPORTS.NUMBAR_OF_FIXED_TABS - 1], copyLast90days[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex]] = [copyLast90days[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex], copyLast90days[REPORTS.NUMBAR_OF_FIXED_TABS - 1]];
        const reorderedLast90days = reOrderList.map((reorderItem)=> copyLast90days.find((listItem)=>listItem.docCategoryName === reorderItem.docCategoryName ))
        await set('reports.statement.last90days',reorderedLast90days );
       
        if(selectedDateRange === SELECTED_RANGE.CUSTOM){
         // [copyCustomRangeList[REPORTS.NUMBAR_OF_FIXED_TABS - 1], copyCustomRangeList[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex]] = [copyCustomRangeList[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex], copyCustomRangeList[REPORTS.NUMBAR_OF_FIXED_TABS - 1]];  
         const reorderedCustomRange = reOrderList.map((reorderItem)=> copyCustomRangeList.find((listItem)=>listItem.docCategoryName === reorderItem.docCategoryName ))
         await set('reports.statement.customRangeList', reorderedCustomRange );
        }

       // [categoryOrder[REPORTS.NUMBAR_OF_FIXED_TABS - 1], categoryOrder[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex]] = [categoryOrder[REPORTS.NUMBAR_OF_FIXED_TABS + rowIndex], categoryOrder[REPORTS.NUMBAR_OF_FIXED_TABS - 1]]; 
       await Promise.all([
        await set('reports.statement.categoryOrder', reOrderList.map(item => item.docCategoryName))
       ]);

        if(selectedDateRange === SELECTED_RANGE.CUSTOM){
          const [customList] = await getValues(
          get('reports.statement.customRangeList'));
          call('reports.setSelectedCategoryId', customList[REPORTS.NUMBAR_OF_FIXED_TABS - 1].docCategoryId, customList[REPORTS.NUMBAR_OF_FIXED_TABS - 1].docCategoryName);
        } else{
          call('reports.setSelectedCategoryId', reorderedLast90days[REPORTS.NUMBAR_OF_FIXED_TABS - 1].docCategoryId, reorderedLast90days[REPORTS.NUMBAR_OF_FIXED_TABS - 1].docCategoryName);
        }
        await set('reports.selectedCategoryTabIndex', REPORTS.VARIABLE_TAB_INDEX);
      },
    })
 

    .path('portfolio.portfolioBPLimit', variable())
    .path('reports.hideDWOPortfolioSelector', variable(false))
    .path('reports.mailBoxIds', variable([]))
    .path('reports.selectedCategoryId', variable(EDELIVERY.UNREAD_CATEGORY_ID))
    .path('reports.selectedCategoryName', variable('Unread'))
    .path('reports.statement.defaultList', variable([]))
    .path('reports.statement.defaultUnreadList', variable([]))

    .path('reports.statement.loading', variable([]))
    .path('reports.duration', variable('for last week'))
    .path('reports.startDate', variable(null))
    .path('reports.endDate', variable(null))
    .path('reports.statement.lastWeek', variable([]))
    .path('reports.statement.lastWeekUnread', variable([]))
    .path('reports.statement.lastWeekTotalUnreadDocs', variable(0))
    .path('reports.statement.lastMonth', variable([]))
    .path('reports.statement.lastMonthUnread', variable([]))
    .path('reports.statement.lastMonthTotalUnreadDocs', variable(0))
    .path('reports.statement.customRangeTotalUnreadDocs', variable(0))
    .path('reports.statement.customRangeList', variable([]))
    .path('reports.statement.customRangeUnreadList', variable([]))
    .path('reports.selectedReportDetailsDateRange', variable(SELECTED_RANGE.LAST_90_DAYS))
    .path('reports.selectedReportType', variable(ReportTypes.STATEMENTS))
    .path('reports.totalUnreadDocs', variable())
    .path('reports.totalDocs7Days', variable(0))
    .path('reports.totalDocs30Days', variable(0))
    .path('reports.totalDocsCustomRange', variable(0))
    .path('reports.isRefreshInProgress', variable(false))
    .path('reports.selectedDetailsTab', variable())
    .path('reports.selectedReportTab', variable())
    .path('reports.blurModalError', variable(null))
    .path('reports.showSpinner', variable(false))
    .path('reports.ShowSpinnerReport', variable(false))
    .path('reports.showUnreadOnlyChecked', variable(false))
    .path('reports.pdfBinaryData', variable(''))
    .path('reports.pdfDataDownloadInProgress', variable(false))
    .path('reports.docIDforDownload', variable())
    .path('reports.transaction.securityAdviceList', variable([]))
    .path('reports.user.reportsPortfoliosData', variable([]))
    .path('reports.openDateRangeTab', variable(false))
    .path('reports.initialReportsCall', variable(true))
    .path('reports.custom.selectedCustomReportType', variable(CUSTOM_REPORT_TYPES.TRANSACTION_HISTORY))
    .path('reports.trans.startDate', variable(ymd(past7Days)))
    .path('reports.trans.endDate', variable(ymd(yesterday)))
    .path('reports.trans.transactionHistoryList', variable())
    .path('reports.trans.isLoading', variable(true))
    .path('reports.trans.dateDisplay', variable(''))
    .path('reports.custom.downloads.result', variable())
    .path('reports.custom.extract.downloads.startDate', variable(ymd(past7Days)))
    .path('reports.custom.extract.downloads.endDate', variable(ymd(yesterday)))
    .path('reports.transactions.showSpinner', variable(false))
    .path('reports.isScrollLoading', variable(false))
    .path('reports.isActiveItemChanged', variable(false))
    .path('reports.closeDatePicker', variable(false))
    .path('reports.custom.startDate', variable(null))
    .path('reports.custom.endDate', variable(null))
    .path('reports.trans.customSelectedTab', variable(0))
    .path('reports.rm.defaultUnreadList', variable([]))
    .path('reports.rm.lastWeekUnread', variable([]))
    .path('reports.rm.lastMonthUnread', variable([]))
    .path('reports.rm.customRangeUnreadList', variable([]))
    .path('reports.rm.lastWeekTotalUnreadDocs', variable(0))
    .path('reports.rm.lastMonthTotalUnreadDocs', variable(0))
    .path('reports.rm.customRangeTotalUnreadDocs', variable(0))
    .path('reports.categoryIDList', variable([]))
    .path('reports.trans.isTransactionSelected',  variable(false))
    .path('reports.selectedCategoryTabIndex', variable(0))
    .path('reports.statement.last90days', variable([]))
    .path('reports.statement.last90daysUnread', variable([]))
    .path('reports.rm.last90daysUnread', variable([]))
    .path('reports.rm.last90daysTotalUnreadDoc', variable(0))
    .path('reports.dropdownDateRangeText', variable(''))
    .path('reports.filterCategory', variable(FILTER_CATEGORY.ALL))
    .path('reports.dropdownRangeSelected', variable(SELECTED_RANGE.LAST_90_DAYS))
    .path('reports.dropdownPrevRangeSelected', variable(SELECTED_RANGE.LAST_90_DAYS))
    .path('reports.statement.categoryOrder', variable([]))
    .path('reports.adhoc.statementTypes', variable([]))
    .path('reports.adhoc.errorMessage', variable(null))
    .path('reports.adhoc.showCancelModal', variable(false));
}
